import BillLading from '@/components/BillLading/BillLading';
import pdf from 'vue-pdf'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
export default {
    name: "collectWriteBillAduitDetail",
	conditionData:'',
	created: function () {
      this.init();
	},
	components:{
        BillLading,
        pdf
    },
    data() {
        return {
			edit: true,
			// showBillLading : true,
			// showPdf :false,
			showBillLading: false,
            showPdf: true,
            pdfSrc: '',
            numPages: 0,
            progress: 0,
            progressShow: true,
            billLadingData: {
                shipper: "shipper input text",
                consignee: "consignee input text",
                notifyParty: "notifyPart input text", ///
                placeOfreceipt: "placeOfreceipt input text",
                vessel: "vessel input text",
                portOfLoading: "portOfLoading input text",
                portOfTransshipment: "portOfTransshipment input text",
                PortOfDischarge: "portOfDischarge input text", ///
                PlaceOfDelivery: "placeOfDelivery input text", //
                freightCharges: "freightAndCharges input text", //
                NoOfOriginal: "noOfOriginal input text", //
                declared: "declared input text",
                voyageNo: "voyageNo input text",
                preCarriageBy: "carriageBy input text", //
                planceAndDate: "planceAndDate input text",
                forwardingAgent: "forAgent input text", //
                signedBy: "",
                typeOfMovement: "typeOfMovement input text",
                blNo: "billNo input text", //
				goodList:[]
              },
			billDetailForm: {
				signer:'',
				issuingParty_label:'',
				billingFee:'',
				issuingTime:'',
				portOfDischarge:'',
				payment:''
			}
        }
    },
    methods: {
        init(){
			// this.conditionData = this.$routerUtil.getParam();
			// if(this.conditionData.row){
			// 	this.billLadingData.shipper = this.conditionData.row.shipper;
			// 	this.billLadingData.consignee = this.conditionData.row.consignee;
			// 	this.billLadingData.notifyParty = this.conditionData.row.notifyParty;
			// 	this.billLadingData.placeOfreceipt = this.conditionData.row.placeOfreceipt;
			// 	this.billLadingData.vessel = this.conditionData.row.vessel;
			// 	this.billLadingData.portOfLoading = this.conditionData.row.portOfLoading;
			// 	this.billLadingData.portOfTransshipment = this.conditionData.row.portOfTransshipment;
			// 	this.billLadingData.PortOfDischarge = this.conditionData.row.PortOfDischarge;
			// 	this.billLadingData.PlaceOfDelivery = this.conditionData.row.PlaceOfDelivery;
			// 	this.billLadingData.freightCharges = this.conditionData.row.freightCharges;
			// 	this.billLadingData.NoOfOriginal = this.conditionData.row.NoOfOriginal;
			// 	this.billLadingData.declared = this.conditionData.row.declared;
			// 	this.billLadingData.voyageNo = this.conditionData.row.voyageNo;
			// 	this.billLadingData.preCarriageBy = this.conditionData.row.preCarriageBy;
			// 	this.billLadingData.planceAndDate = this.conditionData.row.planceAndDate;
			// 	this.billLadingData.forwardingAgent = this.conditionData.row.forwardingAgent;
			// 	this.billLadingData.signedBy = this.conditionData.row.signedBy;
			// 	this.billLadingData.typeOfMovement = this.conditionData.row.typeOfMovement;
			// 	this.billLadingData.blNo = this.conditionData.row.blNo;
			// 	this.billLadingData.goodList = this.conditionData.row.billGoods;
			// 	this.billDetailForm.signer = this.conditionData.row.signatureCompanyId;
			// 	this.billDetailForm.issuingParty_label = this.conditionData.row.sendCompanyId;
			// 	this.billDetailForm.billingFee = this.conditionData.row.sendBillFeeCompanyId;
			// 	this.billDetailForm.issuingTime = this.conditionData.row.sendBillDate;
			// 	this.billDetailForm.portOfDischarge = this.conditionData.row.costId;
			// 	this.billDetailForm.payment = parseInt(this.conditionData.row.payType);
			// }
			// 取数据判断是走表单，还是PDF.修改showBillLading和showPdf(互斥)
            this.conditionData = this.$routerUtil.getParam();
            // this.billLadingData.shipper = this.conditionData.row.table_blCode;
            this.data = this.conditionData.row;
            console.log(this.data);
            if (this.data.billSignatureFile) {
                this.data.billSignatureFile.forEach(file => {
                    if (file.type === 1 && file.isSignature === 1) {
                        this.pdfSrc = pdf.createLoadingTask({url: '/api' + file.file, CMapReaderFactory});
                    }
                });
            }
            this.pdfSrc.onProgress = progress => {
                let tempProgress = progress.loaded / progress.total * 100;
                if(tempProgress > 100){
                    tempProgress = 100;
                }
                this.progress = tempProgress;
                if (this.progress === 100) {
                    setTimeout(() => {
                        this.progressShow = false;
                        for(const key in require.cache) {
                            if(require && require.cache && require.cache[key] && require.cache[key].exports && require.cache[key].exports.default instanceof Uint8Array){
                                console.log(key);
                                delete require.cache[key];
                            }
                        }
                    }, 500);
                }
            };
            this.loadPdfHandler();
		},
		doBack(){
			this.$routerUtil.setParam(this.conditionData.searchForm);
			this.$router.push('seal-confirm-manage');
		},
		loadPdfHandler() {
            this.pdfSrc.promise.then(pdf => {
                this.numPages = pdf.numPages;
            });
        },
    }
}
